/** Menú contextual del lienzo (clic derecho / pulsación larga). */
import type { App } from '../app.ts'
import { closePopover, h, openMenuAtPoint } from './dom.ts'
import { icon } from './icons.ts'

export function openContextMenu(app: App, sx: number, sy: number, clientX: number, clientY: number): void {
  const world = app.renderer.screenToWorld(sx, sy)
  const hit = app.shapeAt(world.x, world.y)
  if (hit && !app.store.selection.includes(hit.id)) app.store.setSelection([hit.id])
  const hasSelection = app.store.selection.length > 0
  const items: HTMLElement[] = []

  if (hasSelection) {
    const first = app.board.get(app.store.selection[0])
    if (first && (first.type === 'note' || first.type === 'text' || first.type === 'shape')) {
      items.push(row('edit', 'Editar texto', 'Enter', () => app.editText(first.id, true)))
    }
    items.push(row('copy', 'Copiar', 'Ctrl+C', () => app.copySelection()))
    items.push(row('duplicate', 'Duplicar', 'Ctrl+D', () => app.duplicateSelection()))
    items.push(h('div', { class: 'menu-sep' }))
    items.push(row('bringFront', 'Traer al frente', 'Ctrl+Shift+]', () => app.bringToFront()))
    items.push(row('sendBack', 'Enviar al fondo', 'Ctrl+Shift+[', () => app.sendToBack()))
    const locked = app.store.selection.every((id) => app.board.get(id)?.locked)
    items.push(row(locked ? 'unlock' : 'lock', locked ? 'Desbloquear' : 'Bloquear', '', () => app.toggleLock()))
    items.push(h('div', { class: 'menu-sep' }))
    items.push(row('trash', 'Eliminar', 'Supr', () => app.deleteSelection(), true))
  } else {
    items.push(row('note', 'Nota adhesiva aquí', 'N', () => app.insertNoteAt(world.x, world.y)))
    items.push(row('text', 'Texto aquí', 'T', () => app.insertTextAt(world.x, world.y)))
    items.push(row('copy', 'Pegar', 'Ctrl+V', () => void app.pasteAt(world.x, world.y)))
    items.push(h('div', { class: 'menu-sep' }))
    items.push(row('select', 'Seleccionar todo', 'Ctrl+A', () => app.selectAll()))
    items.push(row('lock', 'Desbloquear todo', '', () => app.unlockAll()))
    items.push(h('div', { class: 'menu-sep' }))
    items.push(row('palette', 'Formato del fondo', '', () => app.openBackgroundPicker()))
    items.push(row('fit', 'Ajustar a la pantalla', 'Shift+1', () => app.zoomToFit()))
  }

  openMenuAtPoint(h('div', { class: 'menu-list' }, items), clientX, clientY)
}

function row(
  iconName: string,
  label: string,
  shortcut: string,
  onClick: () => void,
  danger = false,
): HTMLElement {
  return h(
    'button',
    {
      class: `menu-item ${danger ? 'is-danger' : ''}`,
      onclick: () => {
        closePopover()
        onClick()
      },
    },
    [
      h('span', { html: icon(iconName, 18), style: 'display:flex;opacity:.75' }),
      label,
      ...(shortcut ? [h('span', { class: 'shortcut' }, [shortcut])] : []),
    ],
  )
}
